import FilesService from "@/services/files";

class FileTypesService {
    _DB_KEY = 'file_types';

    getFileTypes = (db) => {
        return db.collection(this.dbKey).get();
    }

    addFileType = (db, fileType) => {
        const document = db.collection(this.dbKey).doc();
        const body = {
            uuid: document.id,
            value: fileType,
            counter: 0
        };

        return document.set(body);
    }

    incrementCounter = async (db, uuid) => {
        const documentRef = db.collection(this.dbKey).doc(uuid);
        const document = await documentRef.get();
        const data = document.data();

        const payload = {
            counter: data.counter + 1
        }

        return documentRef.update(payload);
    }

    decrementCounter = async (db, uuid) => {
        const documentRef = db.collection(this.dbKey).doc(uuid);
        const document = await documentRef.get();
        const data = document.data();

        const payload = {
            counter: data.counter > 0 ? data.counter - 1 : 0
        }

        return documentRef.update(payload);
    }

    editFileType = async (db, uuid, fileType) => {
        const documentRef = db.collection(this.dbKey).doc(uuid);

        const { docs } = await FilesService.getFiles(db, { fileType: uuid });
        const files = docs.map((doc) => doc.data());

        const payload = {
            uuid: fileType.uuid,
            value: fileType.file_type
        }

        for (const file of files) {
            await FilesService.updateFile(db, file.uuid, { fileType: payload });
        }

        return documentRef.update(payload);
    }

    get dbKey() {
        return this._DB_KEY
    }
}

export default new FileTypesService();



// WEBPACK FOOTER //
// ./src/services/file-types.js